import classNames from 'classnames';
import { Icon, Label } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { PiCheck, PiHeadsetDuotone } from 'react-icons/pi';
import { IChat, THREAD_STATUS } from 'services/chat/types';
import { useGetClientModuleConfiguration } from 'services/configuration';
import { useGetLabel } from 'services/labels';
import { formatMessageDate } from 'utils/global/date.utils';
import { getPlainText } from 'utils/global/plainText.utils';
import './ThreadCard.scss';

interface IThreadCardProps {
  thread: IChat;
  onClick?: (thread: IChat) => void;
}

const ThreadCard = ({ thread, onClick }: IThreadCardProps) => {
  const className = classNames(['thread-card'], {
    unread: thread?.hasUnreadMessage,
  });
  const label = useGetLabel();
  const configuration = useGetClientModuleConfiguration();
  const { t } = useTranslation();
  return (
    <div className={className} onClick={() => onClick && onClick(thread)}>
      <div className='thread-card-icon'>
        <PiHeadsetDuotone />
      </div>
      <div className='thread-card-name'>
        <div className='thread-card-header'>{thread.subject}</div>
        <div className='thread-card-description'>
          {label.data?.id === thread.lastMessage.senderId && (
            <p className='thread-card-sender'>{t('me')}:</p>
          )}
          <p className='thread-card-message'>
            <div className='thread-card-message-content'>
              {getPlainText(thread.lastMessage.body)}
            </div>
          </p>
          <p className='thread-card-time'>
            {formatMessageDate(thread.lastMessage.messageCreatedAt)}
          </p>
        </div>
      </div>
      {thread.messageThreadStatus.id === THREAD_STATUS.open && (
        <Label color='blue'>
          <Icon.AnimatedHourglass />
        </Label>
      )}
      {thread.messageThreadStatus.id === THREAD_STATUS.closed && (
        <Label color='gray'>
          <PiCheck />
        </Label>
      )}
    </div>
  );
};

export default ThreadCard;
